import * as React from "react";
import {
  extensionEventTypes,
  ZExtensionFormBinding,
} from "src/business/extensionBindings";
import { ZExtensionScope } from "src/business/extensions/ZExtension";

import { EventExtensionSection } from "./EventExtensionSection";
import * as styles from "./EventsAndExtensions.module.less";

type PropsEventsAndExtensionsTab = {
  scope: ZExtensionScope;
  value?: ZExtensionFormBinding[];
  onChange?: (bindings: ZExtensionFormBinding[]) => void;
  disabled?: boolean;
};

export const EventsAndExtensionsTab: React.FC<PropsEventsAndExtensionsTab> = ({
  scope,
  value = [],
  onChange,
  disabled,
}) => (
  <div className={styles.root}>
    {extensionEventTypes.map((event) => (
      <EventExtensionSection
        key={event}
        event={event}
        scope={scope}
        bindings={value}
        onChange={onChange}
        disabled={disabled}
      />
    ))}
  </div>
);
